import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import {successToast} from "../../utils/toasts";
import BackEnd from "../../backend/BackEnd";
import {Token, UserContext} from "../../auth/Auth";
import ConfirmationModal from "../../modals/ConfirmationModal";

class TermsModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        showConfirmationModal: false
    };
    termsText =
        "Настоящим в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» от 27.07.2006 года свободно, своей волей и в своем интересе выражаю свое безусловное согласие на обработку моих персональных данных ООО «Артлоджик-СК» (ОГРН 1157746738830, ИНН 7725284401), зарегистрированным в соответствии с законодательством РФ по адресу:\n" +
        "115191, г. Москва, ул. Рощинская 2-я, д.4, оф.503 (далее по тексту - Оператор).\n" +
        "Персональные данные - любая информация, относящаяся к определенному или определяемому на основании такой информации физическому лицу.\n" +
        "Настоящее Согласие выдано мною на обработку следующих персональных данных:\n" +
        "- Название компании;\n" +
        "- Имя;\n" +
        "- Номер заявки;\n" +
        "- Телефон;\n" +
        "- E-mail;\n" +
        "- Предлагаемая  цена.\n" +
        "\n" +
        "Согласие дано Оператору для совершения следующих действий с моими персональными данными с использованием средств автоматизации и/или без использования таких средств: сбор, систематизация, накопление, хранение, уточнение (обновление, изменение), использование, обезличивание, а также осуществление любых иных действий, предусмотренных действующим законодательством РФ как неавтоматизированными, так и автоматизированными способами.\n" +
        "Данное согласие дается Оператору для обработки моих персональных данных в следующих целях:\n" +
        "- предоставление мне услуг/работ;\n" +
        "- направление в мой адрес уведомлений, касающихся предоставляемых услуг/работ;\n" +
        "- подготовка и направление ответов на мои запросы;\n" +
        "- направление в мой адрес информации, в том числе рекламной, о мероприятиях/товарах/услугах/работах Оператора.\n" +
        "\n" +
        "Настоящее согласие действует до момента его отзыва путем направления соответствующего уведомления на электронный адрес info@netpal.ru. В случае отзыва мною согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без моего согласия при наличии оснований, указанных в пунктах 2 – 11 части 1 статьи 6, части 2 статьи 10 и части 2 статьи 11 Федерального закона №152-ФЗ «О персональных данных» от 26.06.2006 г.";

    render() {
        return (
            <Modal {...this.props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Соглашение об использовании</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={this.state.isLoading ? 'form-loading' : ''}>
                        <textarea className="form-control"
                                  style={{width: '100%', height: '450px', marginBottom: '10px', resize: 'none'}}
                                  readOnly={true}
                                  value={this.termsText}/>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary"
                            onClick={() => this.accept()}>
                        Принять
                    </button>
                    <button type="button" className="btn btn-default"
                            onClick={() => this.setState({showConfirmationModal: true})}>
                        Не принять
                    </button>
                </Modal.Footer>
                <ConfirmationModal show={this.state.showConfirmationModal}
                                   onHide={() => this.setState({showConfirmationModal: false})}
                                   onConfirm={() => this.decline()}>
                    Вы уверены, что не принимаете условия соглашения об использовании?
                </ConfirmationModal>
            </Modal>
        );
    }

    async accept() {
        const accept = new BackEnd.Terms.Accept(this);
        const result = await accept.call();

        if (result.success) {
            UserContext.set(result.data);
            successToast('Соглашение об использовании принято. Добро пожаловать в систему!');

            this.props.onHide();
        }
    }

    decline() {
        UserContext.reset();
        Token.reset();

        this.props.onHide();
        window.location.reload();
    }
}

export default TermsModal;


// WEBPACK FOOTER //
// ./src/components/modals/TermsModal.js